var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49219 8.40127C2.49219 7.22852 2.96512 6.5098 3.94382 5.96515L7.97259 3.72309C10.0837 2.54826 11.1392 1.96085 12.2964 1.96085C13.4535 1.96085 14.5091 2.54826 16.6201 3.72309L20.6489 5.96514C21.6276 6.5098 22.1005 7.22852 22.1005 8.40127C22.1005 8.71928 22.1005 8.87829 22.0658 9.009C21.8833 9.69579 21.261 9.80418 20.66 9.80418H3.9327C3.33169 9.80418 2.70937 9.69579 2.52691 9.009C2.49219 8.87829 2.49219 8.71928 2.49219 8.40127Z",
    stroke: "#676767",
    strokeWidth: 1.57
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2928 6.86282H12.3016",
    stroke: "#676767",
    strokeWidth: 1.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 9.80417V18.1377M8.37479 9.80417V18.1377",
    stroke: "#676767",
    strokeWidth: 1.57
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2188 9.80411V18.1376M20.1404 9.80411V18.1376",
    stroke: "#676767",
    strokeWidth: 1.57
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1593 18.1377H5.43344C3.80903 18.1377 2.49219 19.4546 2.49219 21.079C2.49219 21.3497 2.71166 21.5692 2.9824 21.5692H21.6103C21.881 21.5692 22.1005 21.3497 22.1005 21.079C22.1005 19.4546 20.7837 18.1377 19.1593 18.1377Z",
    stroke: "#676767",
    strokeWidth: 1.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerce);
export default __webpack_public_path__ + "static/media/Commerce.91b56d91eaa2ee422c3b896bfd0d8c4e.svg";
export { ForwardRef as ReactComponent };